import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd'
import { Stack, FormControlLabel, Checkbox } from '@mui/material'
import { EFDragIndicatorIcon } from '../EFIcons'
import { IDraggableColumnTableSetting } from './EFTable.model'

export function DraggableColumnTableSetting({
  displayedColumns,
  handleChangeDislayedColumns,
  onDragEnd
}: Readonly<IDraggableColumnTableSetting>) {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId='displayedColumns'>
        {provided => (
          <Stack
            {...provided.droppableProps}
            ref={provided.innerRef}
            direction='column'
            padding={3}
            pt={1}
            pb={0}
            sx={{
              '& *': {
                fontSize: '1rem !important'
              }
            }}
          >
            {displayedColumns.map((column, index) => {
              if (column.id !== '')
                return (
                  <Draggable
                    key={column.id + index}
                    draggableId={column.id}
                    index={index}
                  >
                    {provided => (
                      <Stack
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        direction='row'
                        alignItems='center'
                      >
                        <Stack
                          mr={'10px'}
                          sx={{ cursor: 'grab', height: '1.3rem', width: '1.3rem' }}
                        >
                          <EFDragIndicatorIcon />
                        </Stack>
                        <FormControlLabel
                          control={
                            <Checkbox
                              title={column.label}
                              name={column.id}
                              checked={column.display}
                              sx={{
                                '& .MuiSvgIcon-root': { height: 30, width: 30 }
                              }}
                              style={{ color: 'var(--primary-bg)' }}
                              onChange={handleChangeDislayedColumns}
                            />
                          }
                          sx={{ '& .MuiFormControlLabel-label': { marginLeft: '-10px' } }}
                          label={column.label}
                        />
                      </Stack>
                    )}
                  </Draggable>
                )
              return null
            })}
            {provided.placeholder}
          </Stack>
        )}
      </Droppable>
    </DragDropContext>
  )
}
